import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "../../axios.jsx";
import "./BOSListAcoe.css"
import { useLocation, useNavigate } from "react-router-dom";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

function BOSListAcoe() {

    const [userDetails, setUserDetails] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const navigate = useNavigate();
    const loc = useLocation();
    setInterval(() => {
        if (!Cookies.get("userInfo")) {
            logout();
        }
    }, 1000);
    useEffect(() => {
        if (Cookies.get("username") != loc.state.officer) {
            alert("unauthorized to this page")
            logout();
        }
        async function fetchData() {
            let reqData = {
                note: 'note1'
            };
            try {
                const resData = await axios.post("/api/get-all-bospanel", reqData);
                if (resData.status === 200) {
                    setUserDetails(resData.data.panels_list);
                    console.log(resData.data.panels_list);
                }
            } catch (e) {
                if (e.code === "ERR_BAD_REQUEST") {
                    console.log(e);
                    // logout();
                }
            }
        }
        fetchData();
    }, [])

    const handleChange = (e) => {
        e.preventDefault();
        setSearchInput(e.target.value);
    };

    if (searchInput.length > 0) {
        userDetails.filter((user) => {
            return user.name_of_scholar.match(searchInput);
        });
    }

    const viewPanel=(index)=>{
        navigate("/bospanelprint", { state: { id:userDetails[index].scholar_id } });
    }

    return (
        <>
        <center>
            <div className="parent">

                <input
                    type="search"
                    placeholder="Search here"
                    onChange={handleChange}
                    value={searchInput} />

                <div className="panel-list" id="panel-list">
                    {userDetails.map((scholar, i) => (
                        <div
                            data-toggle="modal" data-target="#exampleModalCenter"
                            key={i}
                            className="pending-item"
                            onClick={() => { viewPanel(i) }}
                        >
                            <i className="i-font">
                                {scholar.scholar_id+" "}
                                
                                {" "+scholar.name_of_scholar}
                            </i>
                            <span className="icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    class="bi bi-arrow-right"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                    />
                                </svg>
                            </span>

                        </div>
                    ))}
                    
                </div>

            </div>
            </center>
        </>
    )
}

export default BOSListAcoe;

function logout() {
    window.localStorage.clear();
    Cookies.remove("userInfo");
    Cookies.remove("username");
    window.location.href = "/officers-login";
}